<script>
import dateProgress from '@/utils/dateProgress';
import taskProgress from '@/utils/taskProgress';
import BaseProgressbar from '../../BaseProgressbar.vue';

export default {
  name: 'BaseTableProgressCell',
  components: { BaseProgressbar },
  props: {
    project: Object,
    type: String,
  },
  computed: {
    dateProgress() {
      return dateProgress(this.project.dateStart, this.project.dateFinish);
    },
    taskProgress() {
      return taskProgress(this.project.numberOfTasks, this.project.numberOfClosedTasks, true);
    },
  },
};
</script>

<template lang="pug">
.progress
  .date(v-if="type === 'date' && this.project.dateFinish")
    BaseProgressbar(v-bind="dateProgress")
  .task(v-if="type === 'task' && this.project.numberOfTasks > 0")
    BaseProgressbar(v-bind="taskProgress")
  .no-date(v-if="type === 'date' && !this.project.dateFinish")
    .label без срока
  .no-task(v-if="type === 'task' && this.project.numberOfTasks === 0")
    .label нет задач
</template>

<style scoped lang="scss">
.label {
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.03em;
  color: #FFFFFF;
  background: rgba(52, 160, 251, 1);
  border-radius: 4px;
  padding: 0 14px;
  box-sizing: border-box;
  height: 24px;
}
</style>
